// extracted by mini-css-extract-plugin
export default {"highlighted-line":"AudioWave_highlighted-line__TX9+f","line":"AudioWave_line__i7CXo","wave-container":"AudioWave_wave-container__9+IE6"};